

import { ViewingAcknowledgmentForm, RentalCommitmentForm } from '@/Domains/Contact';

/*

import SaleMandateForm from './Forms/SaleMandateForm';
import RentManagementMandateForm from './Forms/RentManagementMandateForm';
import SearchPropertyRentMandateForm from './Forms/SearchPropertyRentMandateForm';

import IcaziResidentialLeaseForm from './Forms/IcaziResidentialLeaseForm';
import IcaziProLeaseForm from './Forms/IcaziProLeaseForm';
import IcaziSeasonalLeaseForm from './Forms/IcaziSeasonalLeaseForm';

import PropertyCommercialManualForm from './Forms/PropertyCommercialManualForm';
import ProspectionManualForm from './Forms/ProspectionManualForm';
import ExpenseNoteForm from './Forms/ExpenseNoteForm';


import PropertyRoutineMaintenanceForm from './Forms/PropertyRoutineMaintenanceForm';
import PropertyListingSheetForm from './Forms/PropertyListingSheetForm';

import UploadForm from './Forms/UploadForm';
import PricingForm from './Forms/PricingForm';*/

export const DOCUMENT_FORM_REGISTRY = {
    // ------- Contacts ----
    viewing_acknowledgment: ViewingAcknowledgmentForm,
    rental_commitment: RentalCommitmentForm,
    // ----- Mandates -----
    /** 
    sale_mandate: SaleMandateForm,
    rent_management_mandate: RentManagementMandateForm,
    search_property_rent_mandate: SearchPropertyRentMandateForm,

    // ----- Leases -----
    icazi_residential_lease: IcaziResidentialLeaseForm,
    icazi_pro_lease: IcaziProLeaseForm,
    icazi_seasonal_lease: IcaziSeasonalLeaseForm,

    // ----- Tools -----
    property_commercial_manual: PropertyCommercialManualForm,
    prospection_manual: ProspectionManualForm,
    expense_note: ExpenseNoteForm,

    // ----- Properties -----
    routine_maintenance: PropertyRoutineMaintenanceForm,
    property_listing_sheet: PropertyListingSheetForm,
    
    


    // ----- Others -----
    upload: UploadForm,
    pricing: PricingForm,
    **/
} as const satisfies Record<string, React.FC<any>>;